<div class="modal-content page-preview-modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ title | translate }}</h5>
    <button type="button" class="close" (click)="cancelEvent.emit()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div [innerHTML]="previewHtml"></div>
  </div>
  <div class="modal-footer">
    <wsb-atlas-button
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="cancelEvent.emit()"
      [label]="labelCancelButton"
    ></wsb-atlas-button>
  </div>
</div>
